import axios from "axios";
import { userManager, logout } from "../helper/auth_helper";
import { showLoader, hideLoader } from "../store/loaderStore";
const url = process.env.REACT_APP_BASE_API_URL;
export const getTimezoneOffset = () => {
  const path = window.location.pathname.toLowerCase();

   if (path.includes("revenue") || path.includes("invoices") || path.includes("finance/cod") || path.includes("finance/oracle-invoices")) {
    const timezoneOffsetMinutes = new Date().getTimezoneOffset();
    const sign = timezoneOffsetMinutes <= 0 ? "+" : "-";
    const absMinutes = Math.abs(timezoneOffsetMinutes);
    const hours = String(Math.floor(absMinutes / 60)).padStart(2, "0");
    const minutes = String(absMinutes % 60).padStart(2, "0");
    return `${sign}${hours}:${minutes}`;
  } else {
    const timezoneOffset = new Date().getTimezoneOffset() / 60;
    return timezoneOffset.toString();
  }
};

const dummyToken = process.env.REACT_APP_LOCAL_TOKEN;
const AoneService = axios.create({
  baseURL: url,
  headers: {
    Connection: "keep-alive",
    Timezone: getTimezoneOffset(),
  },
});

// 🔑 Interceptor: runs before every request
AoneService.interceptors.request.use((config) => {
  config.headers["Timezone"] = getTimezoneOffset();
  return config;
});

AoneService.interceptors.request.use(
  async function (config) {
    showLoader();

    // ⬇️ NEW — get latest token from OIDC memory (NOT sessionStorage)
    try {
      const user = await userManager.getUser();
      if (user?.access_token) {
        config.headers.Authorization = `Bearer ${user.access_token}`;
      }
    } catch (e) {
    }

    return config;
  },
  function (error) {
    hideLoader();
    return Promise.reject(error);
  }
);

AoneService.interceptors.response.use(
  function (response) {
    hideLoader();
    return response;
  },
  async function (error) {
    hideLoader();

    if (error.response && error.response.status === 401) {
      await logout();
      window.location.href = process.env.REACT_APP_KEYCLOACK_POST_LOGOUT;
    }

    // Additional error handling
    return Promise.reject(error);
  }
);


// ToroodService: axios instance WITH Authorization header (like AoneService)
export const ToroodService = axios.create({
  headers: {
    Connection: "keep-alive",
    Timezone: getTimezoneOffset(),
  },
});

ToroodService.interceptors.request.use(async (config) => {
  config.headers["Timezone"] = getTimezoneOffset();
  showLoader();

  // Add Authorization token (same as AoneService)
  try {
    const user = await userManager.getUser();
    if (user?.access_token) {
      config.headers.Authorization = `Bearer ${user.access_token}`;
    }
  } catch (e) {
  }
  return config;
});

ToroodService.interceptors.response.use(
  function (response) {
    hideLoader();
    return response;
  },
  async function (error) {
    hideLoader();
    if (error.response && error.response.status === 401) {
      await logout();
      window.location.href = process.env.REACT_APP_KEYCLOACK_POST_LOGOUT;
    }
    return Promise.reject(error);
  }
);

export default AoneService;
